module.exports = __webpack_public_path__ + "img/woman-arm-front.4fad6bd1.png";